CollectionWithHelpers = require 'app/scripts/models/collections/internal/collection-with-helpers'
Tag = require 'app/scripts/models/tag'

class TagList extends CollectionWithHelpers
  model: Tag

  comparator: (tag1, tag2) -> tag1.get('name').localeCompare(tag2.get('name'))

module.exports = TagList
